import { VIDEO_TYPE, AUDIO_TYPE, FILE_UPLOAD_TYPE, } from 'wix-rich-content-common';
import { resolveFileUrl } from '@wix/ricos-media';
export const getVideoUrl = (src) => `https://video.wixstatic.com/${src.pathname}`;
export const getAudioUrl = (src) => `https://static.wixstatic.com/${src.id}`;
export default function urlResolutionStrategy(hasPlugin, instance, metaSiteId, _experiments // eslint-disable-line
) {
    if (!metaSiteId) {
        return { config: {} };
    }
    return {
        config: Object.assign(Object.assign(Object.assign({}, (hasPlugin(VIDEO_TYPE) && {
            [VIDEO_TYPE]: {
                getVideoUrl,
            },
        })), (hasPlugin(AUDIO_TYPE) && {
            [AUDIO_TYPE]: {
                getAudioUrl,
            },
        })), (hasPlugin(FILE_UPLOAD_TYPE) &&
            metaSiteId && {
            [FILE_UPLOAD_TYPE]: {
                resolveFileUrl: resolveFileUrl(metaSiteId, instance),
            },
        })),
    };
}
//# sourceMappingURL=urlResolutionStrategy.js.map